import React from 'react';
import { useCart } from '../CartContext';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import './PaymentPage.css';
import Footer from './Footer';

const stripePromise = loadStripe('pk_live_IdkbpNgg6uh4VSM1j4L4xhiT');

function PaymentPage() {
  const { cart } = useCart();

  if (cart.length === 0) {
    return (
      <div className="payment-page page-enter">
        <div className="payment-container" style={{ textAlign: 'center', padding: '60px 40px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🛒</div>
          <h2 style={{ color: 'white', marginBottom: '12px' }}>Your cart is empty</h2>
          <p style={{ color: '#aaa', marginBottom: '30px' }}>Looks like you refreshed or haven't added any tickets yet.</p>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              padding: '14px 32px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          >
            Browse Events
          </button>
        </div>
       <Footer />
      </div>
    );
  }

  return (
    <div className="payment-page page-enter">
      <div className="payment-container" data-aos="fade-up">
        <h2 style={{ color: 'white', marginBottom: '24px', borderBottom: '2px solid #007bff', paddingBottom: '12px' }}>Payment</h2>
        <Elements stripe={stripePromise}>
          <CheckoutForm cart={cart} />
        </Elements>
      </div>

      {/* Footer added here */}
      <Footer />
    </div>
  );
}

export default PaymentPage;
